<template>
  <!-- 用户管理-交易链接封禁-ig链接解封 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="track_link"
            placeholder="请输入交易链接"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submit"
            >解封</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box"></div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'

export default {
  data() {
    return {
      loading: false, //加载动画
      track_link: '',//要解封的交易链接
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  created() {
  },
  methods: {
    submit() {
      this.loading = true
      if (!this.track_link) {
        this.$message.warning('请先填写交易链接')
        return
      }
      let params = {
        track_link: this.track_link
      }
      postApiData('unseal_fetch_account', params).then(res => {
        if (!res.err) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  }
}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
